/* eslint-disable import/no-default-export, import/order, max-lines, max-lines-per-function, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
// @ts-expect-error TS(6133): 'React' is declared but its value is never read.
import React, { useRef, useEffect } from "react";
import { isPhone } from "common/utils/browser";
import UseSvg from "common/vue/components/UseSvg.react.vue";
import { scrollToTextAreaAndHighlight } from "./dtfUserRetentionHelper";
import { track } from "jiffy-analytics";
import {
  DTF_TRANSFER_USER_RETENTION_CHANGES,
  DTF_TRANSFER_USER_RETENTION_IMAGES,
  MODAL_TRIGGER_POINTS
} from "./constants";
import "./DtfTransferUserRetentionModal.scss";
import { renderList } from "common/vue/render-list";

export default function DtfTransferUserRetentionModal({
  isOpen = false,
  isMultiArtworkModalOpen = false,
  isPinBasedRedrawEnabled = false,
  triggerPoint,
  onUpdateIsOpen,
  ...restProps
}: any) {
  const modalRef = useRef(null);
  const isOpenRef = useRef(isOpen);

  function requestEditsButtonText() {
    if (isPhone()) return "Use Free Artist Edit";
    return isPinBasedRedrawEnabled ? "Get Free Artist Edits" : "Request Artist Edits for Free";
  }

  function beforeImageUrl() {
    return isPinBasedRedrawEnabled
      ? DTF_TRANSFER_USER_RETENTION_IMAGES.PIN_BEFORE_IMAGE_URL
      : DTF_TRANSFER_USER_RETENTION_IMAGES.LEGACY_BEFORE_IMAGE_URL;
  }

  function afterImageUrl() {
    return isPinBasedRedrawEnabled
      ? DTF_TRANSFER_USER_RETENTION_IMAGES.PIN_AFTER_IMAGE_URL
      : DTF_TRANSFER_USER_RETENTION_IMAGES.LEGACY_AFTER_IMAGE_URL;
  }

  function closeModalAndProcessAction() {
    onUpdateIsOpen(false);
    track("exit_intent_modal_ignored", {
      reason: triggerPoint,
      source: "DTF0001"
    });
    if (triggerPoint === MODAL_TRIGGER_POINTS.BACK_BUTTON) {
      window.history.go(-1);
    }
  }

  function onShow() {
    // @ts-expect-error TS(2581): Cannot find name '$'. Do you need to install type ... Remove this comment to see the full error message
    const $modalElement = $(modalRef.current);
    $modalElement
      .modal("show")
      .on("hide.bs.modal", () => {
        if (isOpenRef.current) {
          closeModalAndProcessAction();
        }
      })
      .on("hidden.bs.modal", () => {
        $modalElement.off("hide.bs.modal hidden.bs.modal");
        document.body.classList.remove("dtf-user-retention-modal-open");
      });
    document.body.classList.add("dtf-user-retention-modal-open");
  }

  function onHide() {
    // @ts-expect-error TS(2581): Cannot find name '$'. Do you need to install type ... Remove this comment to see the full error message
    const $modalElement = $(modalRef.current);
    $modalElement.modal("hide");
    document.body.classList.remove("dtf-user-retention-modal-open");
  }

  useEffect(() => {
    isOpenRef.current = isOpen;
  }, [isOpen]);

  useEffect(() => {
    if (isOpen) {
      onShow();
    } else {
      onHide();
    }
  }, [isOpen]);

  function handleRequestEditsButtonClick(event: any) {
    event.preventDefault();
    event.stopPropagation();
    onUpdateIsOpen(false);
    scrollToTextAreaAndHighlight(isMultiArtworkModalOpen ? 1 : 0);
    track("exit_intent_modal_recaptured", {
      reason: triggerPoint,
      source: "DTF0001"
    });
  }

  function handleContinueButtonClick() {
    closeModalAndProcessAction();
  }

  useEffect(() => {
    if (triggerPoint !== MODAL_TRIGGER_POINTS.NONE) {
      track("exit_intent_modal_load", {
        reason: triggerPoint,
        source: "DTF0001"
      });
    }
  }, [triggerPoint]);

  return (
    <div
      {...restProps}
      className="modal user-retention-modal scope-9aa3f230"
      id="user-retention-modal"
      ref={modalRef}
      role="dialog"
      data-testid="modal"
    >
      <div className="user-retention-modal__modal-box modal-dialog scope-9aa3f230">
        <div
          className="user-retention-modal__modal-header scope-9aa3f230"
          role="heading"
          // @ts-expect-error TS(2322): Type 'string' is not assignable to type 'number'.
          tabIndex="0"
          data-testid="user-retention-modal-modal-header"
        >
          <h3 className="user-retention-modal__modal-title scope-9aa3f230">
            {" "}
            Design not perfect? We can help!{" "}
          </h3>
          <button
            className="user-retention-modal__modal-button-close scope-9aa3f230"
            type="button"
            data-testid="close-user-retention-modal-button"
            onClick={closeModalAndProcessAction}
          >
            <UseSvg className="scope-9aa3f230" icon="modal-close-big" data-testid="use-svg" />
          </button>
        </div>
        <div className="user-retention-modal__modal-body scope-9aa3f230">
          <div className="user-retention-modal__info-container scope-9aa3f230">
            <div className="user-retention-modal__info-container-before scope-9aa3f230">
              <h5 className="user-retention-modal__info-container-bold-text scope-9aa3f230">
                {" "}
                Original Upload{" "}
              </h5>
              <img
                className="user-retention-modal__image scope-9aa3f230"
                src={beforeImageUrl()}
                alt="Before"
              />

              <div className="user-retention-modal__info-container-before-text scope-9aa3f230">
                <h5 className="user-retention-modal__info-container-bold-text scope-9aa3f230">
                  {isPinBasedRedrawEnabled
                    ? "Sample message to artist:"
                    : "Sample message to designer:"}
                </h5>
                {isPinBasedRedrawEnabled ? (
                  <ol className="user-retention-modal__info-container-description user-retention-modal__info-container-ordered-list scope-9aa3f230">
                    <li
                      className="scope-9aa3f230"
                      data-testid="user-retention-modal-sample-message-1"
                    >
                      {" "}
                      Add the text "#1 Fan" in white color onto the blue flag.{" "}
                    </li>
                    <li
                      className="scope-9aa3f230"
                      data-testid="user-retention-modal-sample-message-2"
                    >
                      {" "}
                      Change the color of the dog's t-shirt from blue to red.{" "}
                    </li>
                  </ol>
                ) : (
                  <p className="user-retention-modal__info-container-description scope-9aa3f230">
                    {" "}
                    Please remove the pink background, change the ribbon color to blue, remove
                    freckles. Change "It's a girl!" to Emma.{" "}
                  </p>
                )}
              </div>
            </div>
            <div className="user-retention-modal__info-container-arrow-button scope-9aa3f230">
              <UseSvg
                className="user-retention-modal__info-container-arrow-button-icon scope-9aa3f230"
                icon="arrow-right-long"
                data-testid="user-retention-modal-info-container-arrow-button-icon"
              />
            </div>
            <div className="user-retention-modal__info-container-after scope-9aa3f230">
              <h5 className="user-retention-modal__info-container-bold-text scope-9aa3f230">
                {isPinBasedRedrawEnabled ? "Artist Edited" : "Designer Perfected"}
              </h5>
              <img
                className="user-retention-modal__image scope-9aa3f230"
                src={afterImageUrl()}
                alt="After"
              />

              {!isPinBasedRedrawEnabled ? (
                <div className="user-retention-modal__info-container-changes-list scope-9aa3f230">
                  {renderList(DTF_TRANSFER_USER_RETENTION_CHANGES, (change, index) => (
                    <div
                      className="user-retention-modal__info-container-changes-list-item scope-9aa3f230"
                      key={change}
                    >
                      <span className="user-retention-modal__info-container-change-number scope-9aa3f230">
                        {index + 1}
                      </span>
                      <h5 className="user-retention-modal__info-container-bold-text scope-9aa3f230">
                        {change}
                      </h5>
                    </div>
                  ))}
                </div>
              ) : null}
            </div>
          </div>
          <div className="user-retention-modal__action-btns-container scope-9aa3f230">
            <button
              className="user-retention-modal__action-btn scope-9aa3f230"
              type="button"
              data-testid="request-artist-edits-for-free"
              onClick={e => {
                handleRequestEditsButtonClick(e);
              }}
            >
              {requestEditsButtonText()}
            </button>
            <button
              className="user-retention-modal__action-btn user-retention-modal__action-btn--secondary scope-9aa3f230"
              type="button"
              data-testid="continue-button"
              onClick={handleContinueButtonClick}
            >
              {" "}
              Continue{" "}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
